import type { SVGProps } from 'react'
const SvgSyFolderCopy = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M15 17v.5c0 .834-.666 1.5-1.5 1.5H13v1h.5c1.375 0 2.5-1.125 2.5-2.5V17zM3 17v.5C3 18.875 4.125 20 5.5 20H6v-1h-.5c-.834 0-1.5-.666-1.5-1.5V17zM5.5 7A2.51 2.51 0 0 0 3 9.5v.5h1v-.5C4 8.666 4.666 8 5.5 8H6V7zM8 19v1h3v-1zm-5-7v3h1v-3z"
		/>
		<path d="M8 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 3 10.08 3 11.2 3h1.301c.551 0 .827 0 1.082.069a2 2 0 0 1 .631.295c.216.153.393.364.745.787L16.5 6h2.3c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 7.52 22 8.08 22 9.2v2.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 15 19.92 15 18.8 15h-7.6c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C8 13.48 8 12.92 8 11.8z" />
	</svg>
)
export default SvgSyFolderCopy
